export * from './lib/project-model-data-viewer/project-model-data-viewer.component';
export * from './lib/data-insight/data-insight.component';

export * from './lib/state/data-history.reducer';
export * from './lib/state/database.actions';
export * from './lib/data-insight-timeline/data-insight-timeline.component';
export * from './lib/timeline-node-card/timeline-node-card.component';
export * from './lib/data-card/data-card.component';

export * from './lib/database-list/database-list.component';
export * from './lib/project-model-detail/project-model-detail.component';
export * from './lib/navigate-to-project-model/navigate-to-project-model.component';
export * from './lib/database.config';

export * from './lib/workspace-canvas/workspace-canvas.component';

import { provideState } from '@ngrx/store';
import { dataHistoryFeature } from './lib/state/data-history.reducer';

/**
 * Pure function providing the localized NgRx State for the Database module.
 * Intended to be imported into the route providers where Database features are needed.
 */
export function provideDatabaseFeature() {
  return [
    provideState(dataHistoryFeature)
  ];
}